import EntityApi from "../../Api/EntityApi";

class ImageArchiveService {

    constructor(jsonApi, state) {
        this.entityApi = new EntityApi(jsonApi);
        this.jsonApi = jsonApi;
        this.state = state;

        this.state.add('pages', null);
        this.state.add('page', null);
        this.state.add('errorMsg', '');
        this.state.add('loading', false);
        this.state.add('width', 0);
    }

    fetchPages(id) {
        if (this.state.loading) {
            return;
        }
        this.state.setLoading(true);
        this.state.setErrorMsg('');
        this.entityApi.list('Page', 'content',
            (resultType, list, data) => {
                if (data.status === 'success') {
                    this.updateData(list, id);
                }

                this.state.setLoading(false);
            },
            (res) => {
                this.state.setLoading(false);
            },
            -1,
            {key: 'group', value: 'imagearchive'});
    }

    setPage(id) {
        this.state.pages.forEach(p => {
            if (p.id === id) {
                this.state.setPage(p);
                this.calculatePositions(p);
            }

        })
    }

    updateData(list, id) {
        const pages = list;
        pages.sort((a, b) => b.order - a.order);
        pages.forEach(page => {
            page.blocks.sort((a, b) => a.order - b.order)
            page.blocks.forEach(b => b.textSnippets.sort((s1, s2) => s1.order - s2.order))
        })

        this.state.setPages(pages);
        if (id)
            this.setPage(id);
        else if (pages.length > 0)
            this.state.setPage(pages[0]);
    }

    twoColumns() {
        return this.state.width >= 685;
    }

    calculatePositions(page = null) {
        page = page ? page : this.state.page;
        if (!page)
            return
        page.blocks.forEach((b, i) => {
            let blockHeight = 0;
            let prevNeededHeight = 0;
            let topOffset = 0;
            b.textSnippets.forEach((s, i) => {

                const columnCount = this.twoColumns() ? 2 : 1;
                const ratio = s.imageLoaded ? this.state.width / (columnCount * s.dimensions.width) : 0;
                const rowCharCount = this.twoColumns() ? this.state.width / 16 : this.state.width / 8;
                const textRowCount = Math.ceil(s.content.length / rowCharCount) || 1;

                let neededHeight = s.imageLoaded ? ratio * s.dimensions.height + textRowCount * 30 : 300;
                console.log("neededHeight " + neededHeight + " "+topOffset);
                s.top = topOffset;
                s.left = 0;
                if (this.twoColumns()) {
                    if (i % 2) {
                        s.left = this.state.width / 2;
                        neededHeight = Math.max(prevNeededHeight, neededHeight);

                        blockHeight += neededHeight;
                        topOffset += neededHeight;
                    } else if (i === b.textSnippets.length - 1) {
                        blockHeight += neededHeight;
                        topOffset += neededHeight;
                    }
                } else {
                    blockHeight += neededHeight;
                    topOffset += neededHeight;
                }
                prevNeededHeight = neededHeight;
            })
            b.height = blockHeight;
        })
        return true;
    }

    handleImageLoad(e, snippet) {
        const {naturalHeight, naturalWidth} = e.target;
        snippet.dimensions = {height: naturalHeight, width: naturalWidth};
        snippet.imageLoaded = true;
        if (this.calculatePositions())
            this.state.update();
    }

}

export default ImageArchiveService;